import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { PortalUserRequest } from '../_model/request/PortalUserRequest';
import {PortalUserSearchRequest} from '../_model/request/PortalUserSearchRequest';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';

@Injectable({
  providedIn: 'root'
})

export class PortaluserService extends BaseService {

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  saveUser(userSaveRequest: PortalUserRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/portalusers', userSaveRequest);
  }
  listActiveUsers(userSearchRequest: PortalUserSearchRequest): Observable<ApiResponse>{
    return this.post<ApiResponse>('/api/v1/portalusers/actives', userSearchRequest);
  }
  listUser(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/portalusers');
  }
  updateUser(userUpdateRequest: PortalUserRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/portalusers', userUpdateRequest);
  }
  deleteUser(id) {
    return this.delete<ApiResponse>('/api/v1/portalusers/' + id.id);
  }
  getProfile(id: number) {
    return this.get<ApiResponse>('/api/v1/portalusers/profiles/' + id);
  }
}
